export const IntegrationProviders = {
    KLAVIYO: 'Klaviyo',
    META: 'Meta',
    GOOGLE: 'Google',
    SHOPIFY: 'shopify',
}

export const BASE_PATH_AFTER_SUCCESSFUL_AUTH = '/account'
export const AUTH_BASE_PATH = '/auth/login'

let basePath = 'creative'
try {
    const basePathFromLocalStorage = localStorage.getItem('basePath')
    if (basePathFromLocalStorage) {
        basePath = basePathFromLocalStorage
    }
} catch (e) {
    console.error(e)
}

export const DASHBOARD_ROOT = basePath

export const UserRoles = {
    OWNER: 'owner',
    ADMIN: 'admin',
    EDITOR: 'editor',
    VIEWER: 'viewer',
    GUEST: 'guest',
}

export const RoleToWeight = {
    [UserRoles.OWNER]: 100,
    [UserRoles.ADMIN]: 90,
    [UserRoles.EDITOR]: 30,
    [UserRoles.VIEWER]: 20,
    [UserRoles.GUEST]: 10,
}
